import { render, staticRenderFns } from "./PlanoInfusao.vue?vue&type=template&id=79f8fd23&"
import script from "./PlanoInfusao.vue?vue&type=script&lang=js&"
export * from "./PlanoInfusao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports